import React, { useState } from 'react';
import './StemCard.scss'
import Link from '../Link';
import { translate } from 'react-polyglot';
import {stemImages, links, subjectsStem} from '../../lib/constants';
import classNames from 'classnames';
import Bookmark from './Bookmark';
import { addNotificationModal , removeNotificationModal } from '../../redux/notificationModalActions';
import {openAuthModal} from '../../redux/userActions';
import { connect } from 'react-redux';

const mapStateToProps = ({ viewport, user }) => ({
  viewport,
  isLoggedIn: user.isLoggedIn
})

const mapDispatchToProps = {
  openAuthModal,
  addNotificationModal,
  removeNotificationModal
}

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('language') || 'en';

const StemCard = ({ lessonPlan, t, bmText, triggerEvent, bookmarkEvent, isFromStemOffline, parentClassName, isRtl, stemLang, isLoggedIn, openAuthModal, viewport, addNotificationModal, removeNotificationModal}) => {
  
  const baseClassName = 'pb-stem-card';

  const classes = {
    [baseClassName]: true,
    [`${baseClassName}--rtl`]: isRtl,
    [parentClassName]: parentClassName
  };
  
  const subClasses = {
    [`${baseClassName}__sub-title`]: true,
    [`${baseClassName}__sub-title--offline`]: isFromStemOffline
  };

  let isMath = lessonPlan.attributes.subject.toLowerCase() === subjectsStem[0].toLowerCase()
  let stemCardClickCount = parseInt((localStorage.getItem("stemCard-click-count")),10) || 0;
  const [status, setStatus] = useState(false);

  const handleStemCardClick = () => {
    if (isLoggedIn || isFromStemOffline) {
      return triggerEvent();
    } else if (stemCardClickCount < 1) {
      setStatus(true);
      return triggerEvent();
    } else{
      setStatus(false);
      addNotificationModal({
        title: t("global.log-in"),
        content: t("global.login-for-lp"),
        additionalActions: [{
          label: t('global.log-in'),
          primary: true,
          onClick: () => { removeNotificationModal(); openAuthModal(); }
        }, {
          label: t('global.sign-up'),
          onClick: () => { removeNotificationModal(); openAuthModal(); }
        }]
      })
    }
  };

  const stemCardBlock = (
    <div className={classNames(classes)} dir={isRtl? "rtl" : "ltr"}>
      <Link parentClassName={`${baseClassName}__banner-wrapper`} theme="csf" href={isLoggedIn || status || isFromStemOffline ? links.stemLP(isMath? "maths" : "science" ,lessonPlan.id, stemLang ? stemLang : lang) : null} onClick={handleStemCardClick}>
        <div className={`${baseClassName}__banner`}>
          <img src={isMath ? stemImages.stemMathShadow : stemImages.stemScienceShadow} alt={'math'} className={`${baseClassName}__banner-image`}/>
          <img src={isMath ? stemImages.stemMathBlue : stemImages.stemScienceOrange} alt={'math-shadow'} className={`${baseClassName}__banner-image`}/>
          <img src={isMath ? stemImages.stemMathLogo : stemImages.stemScienceLogo} alt={'mathIcon'} className={isRtl ? `${baseClassName}__banner-icon--rtl ${baseClassName}__banner-icon` : `${baseClassName}__banner-icon`}/>
        </div>
        <h3 className={`${baseClassName}__title`}>{lessonPlan.attributes.name}</h3> 
      </Link>
      <p className={classNames(subClasses)}> <span className={`${baseClassName}__sub-title--grade`}>{t('global.grade', {grade: lessonPlan.attributes.grade.split(" ")[1]})}</span>
        {!isFromStemOffline && isLoggedIn && <Bookmark lessonPlan={lessonPlan} t={t} bmText={bmText || t('global.bookmark')} bookmarkEvent={bookmarkEvent} isRtl={isRtl} />}
      </p>
    </div>
  ) 

  return (
    <div> 
      {
        stemCardBlock
      }
    </div>
  );
}

export default translate()(connect(mapStateToProps, mapDispatchToProps)(StemCard));



// WEBPACK FOOTER //
// ./src/components/StemCard/StemCard.jsx